import { render, staticRenderFns } from "./AnnouncementsPage.vue?vue&type=template&id=ed12347c&scoped=true"
import script from "./AnnouncementsPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementsPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsPage.vue?vue&type=style&index=0&id=ed12347c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed12347c",
  null
  
)

export default component.exports